import { createFileRoute } from "@tanstack/react-router";
import { useMutation } from "@tanstack/react-query";
import { crmProcesarBajaColdEmail } from "@/server/crm/cold-email/opt-out.fns";

export const Route = createFileRoute("/baja-cold-email")({
  validateSearch: (search) => ({ token: typeof search.token === "string" ? search.token : "" }),
  component: BajaColdEmailPage,
});

function Shell({ children }: { children: React.ReactNode }) {
  return (
    <main className="min-h-screen bg-gray-50 flex items-start justify-center p-6">
      <div className="w-full max-w-md bg-white border rounded-lg p-6 space-y-4 mt-10">
        <h1 className="text-xl font-semibold text-gray-900">Darte de baja</h1>
        {children}
      </div>
    </main>
  );
}

function BajaColdEmailPage() {
  const { token } = Route.useSearch();

  // Idempotente por diseño (ver crmProcesarBajaColdEmail): un token
  // inválido o ya usado nunca muestra un error técnico, así que no hace
  // falta cargar/validar el token antes de mostrar el botón de confirmación.
  const mutation = useMutation({
    mutationFn: () => crmProcesarBajaColdEmail({ data: { token } }),
  });

  if (!token) {
    return (
      <Shell>
        <p className="text-sm text-gray-600">El enlace no contiene un token válido.</p>
      </Shell>
    );
  }

  if (mutation.isSuccess) {
    return (
      <Shell>
        <p className="text-sm text-green-700">
          Listo — no volverás a recibir este tipo de correos de nuestra parte.
        </p>
      </Shell>
    );
  }

  return (
    <Shell>
      <p className="text-sm text-gray-600">
        Confirma para dejar de recibir este tipo de correos de Improve Yourself — Agencia BTL.
      </p>
      <button
        type="button"
        onClick={() => mutation.mutate()}
        disabled={mutation.isPending}
        className="w-full rounded-md bg-gray-900 text-white text-sm font-medium py-2 disabled:opacity-40 hover:bg-black"
      >
        {mutation.isPending ? "Procesando…" : "Confirmar baja"}
      </button>
    </Shell>
  );
}
